var _path, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_364",
    "data-name": "Groupe 364",
    transform: "translate(-258.929 -47.694)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_561",
    "data-name": "Trac\\xE9 561",
    d: "M292.929,95.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.437.06,14.748,0,17.6-.028,3.555-.039,3.623-.038,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623V89.736A6.007,6.007,0,0,1,292.929,95.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V65.03c-1.459-2.04-8.434-10.826-10.492-13.338-.461,0-1.112.008-1.853.016C279.719,51.739,274.389,51.794,264.924,51.736Z",
    fill: "#3bc14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "X",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "X-2",
    "data-name": "X",
    transform: "translate(270.429 85.736)",
    fill: "#3bc14e",
    fontSize: 24,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.025em",
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelDm);
export default __webpack_public_path__ + "static/media/excelDM.dddf0a6e152f7818348abc826b5b00d1.svg";
export { ForwardRef as ReactComponent };